import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Kāore i kitea te whārangi',
  title: 'Kāore i kitea e mātou taua whārangi',
  body: 'Kua tawhito pea te hononga, kua tangohia rānei te whārangi. Kōrero mai he aha tāu e whai ana, ā, mā mātou e kimi.',
  suggestionsTitle: 'Tērā pea e rapu ana koe i',
  bestMatchTitle: 'Ko tēnei pea tāu',
  prefillHint: 'Kua whakakīia mai i te wāhitau i whakamātauria e koe',
  goHome: 'Kāinga',
  browseAll: 'Ngā wāhanga katoa',
  reportBrokenLink: 'Whakamōhio mai mō tētahi hononga pakaru',
  noticeTitle: 'Kāore taua whārangi i te wātea',
  noticeSearching: 'Kei te rapu kē i {query}…',
  noticePrefilled: 'Rapua {query} i raro nei, kōrero mai rānei he aha tāu e whai ana.',
  errorTitle: 'I hē tētahi mea',
  errorBody: 'Kāore i taea e mātou te uta i tēnei whārangi. Whakamātauria anō, rapua rānei tāu e hiahia ana i raro nei.',
  retry: 'Whakamātau anō',
  streamLostTitle: 'Kāore i taea e mātou te whakaoti i tēnei whārangi',
  streamLostBody: 'I mutu te rapunga i mua i te tiakitanga o te whārangi. Tīmataria anō, ā, ka mahi anō mātou i runga i ō kupu.',
  relaunch: 'Rapu anō',
};
